import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-snackbar-internal-not-authorized',
	templateUrl: './snackbar-internal-not-authorized.component.html',
	styleUrl: './snackbar-internal-not-authorized.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class SnackbarInternalNotAuthorizedComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarInternalNotAuthorizedComponent>
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
